<template>
  <a-spin :spinning="confirmLoading">
    <a-tabs defaultActiveKey="1" type="card" @tabClick="onTabClick">
      <a-tab-pane tab="当前版本" key="1">
        <j-form-container :disabled="formDisabled">
        <a-form :form="form" slot="detail">
          <a-row>
            <a-col :span="24" v-if="isEdit">
              <a-form-item label="项目名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-search-select-tag type="list" v-decorator="['projId', validatorRules.name]" :trigger-change="true" dict="proj_project,name,id" :async="true" placeholder="请选择项目" disabled/>
              </a-form-item>
            </a-col>
            <a-col :span="24" v-else> <!--新增情况,过滤掉已经提交的-->
              <a-form-item label="项目名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-search-select-tag type="list" v-decorator="['projId', validatorRules.name]" :trigger-change="true" :dictOptions="projectOptions" placeholder="请选择项目"/>
              </a-form-item>
            </a-col>

            <!--<a-col :span="24">
              <a-form-item label="客户来源渠道" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-dict-select-tag type="list" v-decorator="['customerSourceType', validatorRules.customerSourceType]" :trigger-change="true" dictCode="bms_customer_source_type" placeholder="请选择客户来源渠道"/>
              </a-form-item>
            </a-col>-->
            <a-col :span="24">
              <a-form-item label="授权委托书" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-upload v-decorator="['attorneyUrl']" :disabled="disabled" :trigger-change="true" bizPath="project-initiation" placeholder="请上传授权委托书"/>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item label="合作协议" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-upload v-decorator="['agreementUrl']" :disabled="disabled" :trigger-change="true" bizPath="project-initiation" placeholder="请上传合作协议"/>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item label="中标通知书" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-upload v-decorator="['bidWinningNoticeUrl']" :disabled="disabled" :trigger-change="true" bizPath="project-initiation" placeholder="请上传中标通知书"/>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item label="保单" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-upload v-decorator="['policyUrl']" :disabled="disabled" :trigger-change="true" bizPath="project-initiation"/>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item label="其他" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-upload v-decorator="['otherUrl']" :disabled="disabled" :trigger-change="true" bizPath="project-initiation"/>
              </a-form-item>
            </a-col>

            <a-col :span="24" v-if="showAuditRemark">
              <a-form-item label="审核备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['auditRemark',{}]"/>
              </a-form-item>
            </a-col>

            <a-col :span="24" v-if="!formDisabled">
              <a-form-item label="模板下载" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a style="margin-right:30px;" :href="`${path}授权委托书模板.docx`" download="授权委托书模板.docx">授权委托书模板</a>
                <a style="margin-right:30px;" :href="`${path}合作协议模板.docx`" download="合作协议模板.docx">合作协议模板</a>
                <!-- <a style="margin-right:30px;" :href="`${path}zbtzs.docx`" download="中标通知书模板.xls">中标通知书模板</a> -->
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </j-form-container>
      </a-tab-pane>

      <a-tab-pane v-for="version in tabs" :tab="version" :key="version">
        <j-form-container disabled>
          <a-form slot="detail">
            <a-row>
              <a-col :span="24" v-if="isEdit">
                <a-form-item label="项目名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <!-- 历史版本 tab 为只读回显，tabModel.name 存的是项目名称文本(非 id)，
                       用 proj_project,name,id 字典匹配不上(该字典 value 是 id)，原先靠 a-select
                       找不到 option 时回退显示原值才正常，代价是每次都全量拉 1469 条项目。
                       直接用只读输入框显示该文本，效果一致且不再请求字典。 -->
                  <a-input v-model="tabModel.name" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="授权委托书" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-upload v-model="tabModel.attorneyUrl"  bizPath="project-initiation" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="合作协议" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-upload v-model="tabModel.agreementUrl"  bizPath="project-initiation" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="中标通知书" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-upload v-model="tabModel.bidWinningNoticeUrl"  bizPath="project-initiation" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="保单" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-upload v-model="tabModel.policyUrl" bizPath="project-initiation" disabled/>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="其他" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-upload v-model="tabModel.otherUrl" bizPath="project-initiation" disabled/>
                </a-form-item>
              </a-col>

              <a-col :span="24" v-if="showAuditRemark">
                <a-form-item label="审核备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model="tabModel.auditRemark" disabled/>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </j-form-container>
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>

<script>

  import { httpAction, postAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JSearchSelectTag from "@/components/dict/JSearchSelectTag"
  import JEditor from '@/components/jeecg/JEditor'
  import JUpload from '@/components/jeecg/JUpload'
  import ProjectStatus from '../../ProjectStatus'
  import ProjectConst from '../../ProjectConst'

  export default {
    name: 'ProjectInitiationForm',
    components: {
      JUpload,
      JFormContainer,
      JDate,
      JSearchSelectTag,
      JDictSelectTag,
      JEditor,
    },
    props: {
      //表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        tabs: [],
        projectOptions: [],
        tabModel: {},
        description: '项目计划申请页面',
        form: this.$form.createForm(this),
        isEdit: false,
        path: ProjectConst.OSS_ADR_TEMPLATE,
        model: {
        },
        fileList:[],
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          name: {
            rules: [
              { required: true, message: '请选择项目!'},
            ]
          },
          customerName: {
            rules: [
              { required: true, message: '请输入客户名称!'},
              { max: 50, message: '项目简称长度不能超过50个字符!'},
              { whitespace: true, message:'不能为空格'}
            ]
          },
          customerSourceType:{
            rules: [
              { required: true, message: '请选择客户来源渠道!'},
            ]
          },
          customerType:{
            rules: [
              { required: true, message: '请选择客户单位性质!'},
            ]
          },
          customerAssets:{
            rules: [
              { max: 500, message: '资产/工程投资情况长度不能超过500个字符!'},
              { whitespace: true, message:'不能为空格'}
            ]
          },
          customerPeople:{
            rules: [
              { max: 500, message: '人员情况长度不能超过500个字符!'},
              { whitespace: true, message:'不能为空格'}
            ]
          },
          customerCar:{
            rules: [
              { max: 500, message: '车辆情况长度不能超过500个字符!'},
              { whitespace: true, message:'不能为空格'}
            ]
          },
          customerCostBudget: {
            rules: [
              { required: true, message: '费用预算情况不能为空!'},
              { max: 500, message: '费用预算长度不能超过500个字符!'},
              { whitespace: true, message:'不能为空格'}
            ]
          },
          progress: {
            rules: [
              //{ required: true, message: '不能为空!'},
              { max: 500, message: '项目进展长度不能超过500个字符!'},
              { whitespace: true, message:'不能为空格'}
            ]
          },
        },
        url: {
          add: "/project/initiation/add",
          edit: "/project/initiation/edit",
          queryById: "/project/initiation/queryById",
          updateFilePath:"/project/initiation/updateFilePathImmediate",
          hisData:"/project/initiation/hisData",
        }
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      showAuditRemark(){
        if(this.model != null && this.model.auditRemark 
          && (this.model.status === this.projectStatus.CANCEL || this.model.status === this.projectStatus.INITATION_WAIT)){
          return true
        }
        return false
      }
    },
    created () {
      this.projectStatus = ProjectStatus
      this.loadProjectOptions()
    },
    methods: {
      loadProjectOptions() {
        getAction("/project/baseInfo/optionList", {status: this.projectStatus.INITATION_WAIT}).then(res => {
          if (res.success) {
            this.projectOptions = res.result || []
          } else {
            this.$message.warning(res.message)
          }
        })
      },
      onTabClick(key) {
        if(key == 1) {return;}
        let url = this.url.hisData;
        let tempModel = this.tabModel;
        let param = {version: key,projId: this.tabModel.projId};
        postAction(url,param).then((res)=>{
          if(res.success){
            if(res.result){
              // tempModel['projNum'] = '测试Click'+key;
              Object.keys(res.result).forEach(key => {
                tempModel[key] = res.result[key]
              })
            } else {
              callback('未找到该项目');
            }
          }else{
            callback(res.message);
          }
        })
      },
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        //编辑、详情禁止修改
        if(this.model.id){
          this.isEdit = true;
        }else{ // 新增可以修改
          this.isEdit = false;
          this.model.status = '0'; // 初始为未提交状态
        }
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.form.setFieldsValue(pick(this.model,'projId','customerName','attorneyUrl', 'agreementUrl',
              'bidWinningNoticeUrl', 'policyUrl','otherUrl','auditRemark'))
          })
        })
        let vs = this.model.versions
        if(vs) {
          this.tabModel = Object.assign({}, record);
          this.tabs = vs.split(',');
        } else {
          this.tabs = []
        }
      },

      // 文件变化
      handleFileChange(){
        // 编辑状态下变化，存在单据id
        let id = this.model.id
        if(id){
          postAction(this.url.updateFilePath, {id: id, filePath: filePath}).then(res =>{
            if(res.success){
            } else {
              this.$message.warn("附件更新时出现错误:" + res.message)
            }
          })
        }
      },

      submitForm () {
        const that = this;

        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            // 检查是否上传了任一文件
            if(!values.attorneyUrl && !values.agreementUrl && !values.bidWinningNoticeUrl 
                && !values.policyUrl && !values.otherUrl){
              that.$message.warning("请上传至少任一项目立项凭证")
              return
            }
            
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }

            let formData = Object.assign(this.model, values);
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
        })
      },

      // trimFormData(formData){
      // },
      popupCallback(row){
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'projId','customerName','attorneyUrl', 'agreementUrl',
            'bidWinningNoticeUrl', 'policyUrl','otherUrl','auditRemark'))
        })
      },
    }
  }
</script>

<style>

</style>